import { render } from "./EphemeridesDownload.vue?vue&type=template&id=4af07b36"
import script from "./EphemeridesDownload.vue?vue&type=script&lang=js"
export * from "./EphemeridesDownload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__